/**
 * The entry point of the player.
 */

require('../public/css/player/main.css')

let debug
try {
  debug = window.debug = window.localStorage ? localStorage.getItem('debug') ? true : false : false
} catch (e) {
  debug = false
}
window.Player = require('./player');
const Player = window.Player;
Player.start('#player', {debug: debug, byBroadcastor:false})



// WEBPACK FOOTER //
// ./src/main.js